// ToDo: Please remove this file
const supportsPassiveEvents = true;

export { supportsPassiveEvents };
